require("./seats-form.scss")

import { Component, Input }  from '@angular/core';
import { NgForm }     from '@angular/forms';
import { EventApi, HttpClient, SaleableSeatApi, SaleableSeatsAmount, SaleableSeatsAvailability }   from "../../services/webservice";
import { Spinner } from "../../ui-helper"
import { Observable } from 'rxjs'


@Component({
	selector: 'seats-form',
	templateUrl: "./seats-form.html"
})
export class SeatsForm {
	public saleableSeatsAvailabilityList: SaleableSeatsAvailability[] = []
	public showSpinner: boolean = false;

	private eventUrl: string;
	private loadedEvent: Event;

	@Input() set eventSelfUrl(eventSelfUrl: string) {
		if (!eventSelfUrl) return;
		this.eventUrl = eventSelfUrl;
		this.loadSaleableSeats();
	}

	constructor(private saleableSeatApi: SaleableSeatApi, private httpClient: HttpClient) {
	}

	public updateSaleableSeats() {
		this.showSpinner = true;
		let saleableSeatsAmount = Observable.from(this.saleableSeatsAvailabilityList)
			.flatMap(saleableSeatsAvailability => this.saleableSeatApi.updateSaleableSeats(
				this.eventUrl, saleableSeatsAvailability.categoryId, saleableSeatsAvailability.saleableSeatAmount.total)
			)
			.toArray()
			.subscribe(
			value => console.log("success", value),
			error => {
				console.log("Error", error)
				this.loadSaleableSeats()
			},
			() => {
				this.loadSaleableSeats()
			}
			)
	}

	private loadSaleableSeats() {
		this.showSpinner = true;
		this.saleableSeatApi.getAmountOfSeats(this.eventUrl).subscribe((result: SaleableSeatsAvailability[]) => {
			this.saleableSeatsAvailabilityList = result
			this.showSpinner = false;
		}
		)
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/seats-form/seats-form.component.ts